import React from 'react';
import ReactDOM from 'react-dom';
import DatePicker from 'react-datepicker';
import moment from 'moment';

class DatePickerDisplay extends React.Component {
  constructor(props) {
    super(props);

    const OneYearFromNow = moment().add(36, 'M')

    this.state = {
      startDate: this.props.startDate,
      maxDate: OneYearFromNow
    };

    this.handleChange = this.handleChange.bind(this);

    if (this.props.targetInputEl) {
      document.querySelector(this.props.targetInputEl).value = this.props.startDate;
    }
  }

  handleChange(date) {
    this.setState({
      startDate: date
    });

    if (this.props.targetInputEl) {
      document.querySelector(this.props.targetInputEl).value = date;
    }
  }

  render() {
    return (
      <div>
        <DatePicker 
          showTimeSelect={this.props.showTimeSelect? true : false} 
          disabledKeyboardNavigation={true}
          maxDate={this.state.maxDate}
          timeFormat="HH:mm"
          dateFormat={this.props.dateFormat}
          placeholderText={this.props.placeHolderText}
          locale="pt-br"
          name={this.props.name} 
          className={this.props.className}
          timeCaption="Horário"
          selected={this.state.startDate}
          autoComplete="off"
          onChange={this.handleChange} 
        />

        {this.state.maxDate < this.state.startDate &&
          <p><small className="text-danger">A data de término não deve ultrapassar 1 ano</small></p>
        }
      </div>
    )
  }
}

export default DatePickerDisplay;
